import { ProductStock } from '@/api/product';
import { AvatarFrameOption } from '../types';

const AVATAR_FRAME_CATEGORY = '头像框';

/**
 * 从 API 响应中提取商品记录
 */
export const extractProductRecords = (productListData: any): ProductStock[] => {
  if (productListData?.records) {
    return productListData.records;
  }
  if (productListData?.data?.records) {
    return productListData.data.records;
  }
  if (Array.isArray(productListData)) {
    return productListData;
  }
  return [];
};

/**
 * 过滤并格式化头像框数据
 */
export const filterAvatarFrameOptions = (
  records: ProductStock[]
): AvatarFrameOption[] => {
  if (!records || records.length === 0) {
    return [];
  }

  return records
    .filter((item) => item.categoryTitle === AVATAR_FRAME_CATEGORY)
    .map((item): AvatarFrameOption => ({
      productStockId: item.productStockId,
      productTitle: item.productTitle,
      categoryTitle: item.categoryTitle,
      avatarFrameImage: (item as any).avatarFrameImage || '',
      productDesc: (item as any).productDesc || item.productTitle || '',
    }));
};

